import script from "./Urn.vue?vue&type=script&setup=true&lang=js"
export * from "./Urn.vue?vue&type=script&setup=true&lang=js"

import "./Urn.vue?vue&type=style&index=0&id=11f3d401&lang=css"

const __exports__ = script;

export default __exports__